<template>
    <div class="slsy-loader">
        <div class="slsy-loader__circle" :style="styleObject">
            <svg viewBox="22 22 44 44">
                <circle cx="44" cy="44" r="20.2" fill="none" stroke-width="3.6"></circle>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: Number,
            default: 20,
        },
    },
    computed: {
        styleObject() {
            return {
                height: `${this.size}px`,
                width: `${this.size}px`,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.slsy-loader {
    align-items: center;
    color: $gray-100;
    display: inline-flex;
    justify-content: center;
    &__circle {
        animation: 1.4s linear 0s infinite normal none running slsy-rotate;
    }
    svg {
        display: block;
        circle {
            stroke: currentColor;
            stroke-dasharray: 80px, 200px;
            stroke-dashoffset: 0;
            animation: slsy-loader 1.4s ease-in-out infinite;
        }
    }
}

@keyframes slsy-rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes slsy-loader {
    0% {
        stroke-dasharray: 1px, 200px;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 100px, 200px;
        stroke-dashoffset: -15px;
    }
    100% {
        stroke-dasharray: 100px, 200px;
        stroke-dashoffset: -125px;
    }
}
</style>
